/* lead-sofort.js – 05.10.2026
   Kontakt sofort speichern: sobald Name + gültige E-Mail (und, falls vorhanden, Telefon) stehen
   und der Kontaktbereich verlassen wird, geht EINMAL eine Teil-Absendung (partial: true) an die
   Lead-Strecke. Die Schlussabsendung ergänzt denselben Lead (n8n dedupliziert je Kontakt und Tag)
   und schickt partial_age_ms mit, damit n8n bei sehr schneller Folge kurz wartet.
   12.10.2026: Ist das Telefonfeld Pflicht, geht die Teil-Absendung nur noch MIT gültiger Nummer
   (mindestens 9 Ziffern) raus, und das Feld selbst verlangt 9 Ziffern (setCustomValidity), damit
   auch die Schlussabsendung keinen Lead ohne Nummer erzeugt. Vorher wurden Abbrecher ohne Nummer
   beim Verlassen der Seite trotzdem gesendet und landeten als Lead ohne Telefon bei den Settern. */
(function () {
  if (window.LeadSofort) return;
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function digits(v) { return String(v || '').replace(/\D/g, '').length; }
  var MIN_DIGITS = 9;
  function phoneMsg() {
    var l = String(document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
    return ({
      fr: 'Merci d’indiquer un numéro de téléphone valable (au moins 9 chiffres).',
      it: 'Inserisci un numero di telefono valido (almeno 9 cifre).',
      en: 'Please enter a valid phone number (at least 9 digits).'
    })[l] || 'Bitte gib eine gültige Telefonnummer ein (mindestens 9 Ziffern).';
  }
  /* Pflicht-Telefonfeld: verlangt mindestens 9 Ziffern, sonst blockiert checkValidity() das Absenden */
  function guardPhone(el) {
    if (!el || el.__leadSofortPhone) return;
    el.__leadSofortPhone = true;
    var check = function () {
      if (!el.required) { el.setCustomValidity(''); return; }
      var v = String(el.value || '').trim();
      el.setCustomValidity(v && digits(v) < MIN_DIGITS ? phoneMsg() : '');
    };
    el.addEventListener('input', check);
    el.addEventListener('change', check);
    el.addEventListener('blur', check);
    check();
  }
  function send(url, payload) {
    if (!url) return;
    try {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true, body: JSON.stringify(payload) })
        .catch(function () {});
    } catch (e) {}
  }
  /* opts: url (String|Function), get() -> {first_name,last_name,name,email,phone,...},
     needName (Standard true), needPhone (Standard: wenn get().phone !== undefined), phoneEl (Element, optional),
     when() -> Boolean (optional, z. B. nur bei Verkaufsthemen) */
  function attach(form, opts) {
    if (!form || form.__leadSofort) return;
    var st = form.__leadSofort = { sent: 0 };
    guardPhone(opts.phoneEl);
    function url() { return typeof opts.url === 'function' ? opts.url() : opts.url; }
    function ready() {
      var d = opts.get() || {};
      var name = String(d.first_name || d.firstname || d.name || '').trim();
      if (opts.needName !== false && !name) return null;
      if (!EMAIL.test(String(d.email || '').trim())) return null;
      if (opts.when && !opts.when()) return null;
      var phoneNeeded = d.phone !== undefined && opts.needPhone !== false && !(opts.phoneEl && !opts.phoneEl.required);
      if (phoneNeeded && digits(d.phone) < MIN_DIGITS) return null;
      return d;
    }
    function trySend(force) {
      if (st.sent || !url()) return;
      var d = ready();
      if (!d) return;
      var p = {};
      for (var k in d) if (Object.prototype.hasOwnProperty.call(d, k)) p[k] = typeof d[k] === 'string' ? d[k].trim() : d[k];
      if (!p.source) p.source = window.location.href;
      p.partial = true;
      st.sent = Date.now();
      send(url(), p);
    }
    form.addEventListener('focusout', function (e) {
      var to = e.relatedTarget;
      setTimeout(function () {
        // Fokus springt ins (noch leere) Telefonfeld: noch warten. Sonst senden, sobald alles gültig ist.
        var phoneNext = opts.phoneEl && to === opts.phoneEl;
        trySend(!phoneNext && !(to && form.contains(to) && /tel/.test(to.type || '')));
      }, 0);
    }, true);
    form.addEventListener('change', function () { setTimeout(function () { trySend(false); }, 0); }, true);
    var hide = function () { if (!st.done) trySend(true); };
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') hide(); });
    window.addEventListener('pagehide', hide);
  }
  /* Für die Schlussabsendung: Alter der Teil-Absendung in ms (oder null) und Formular als erledigt markieren */
  function finish(form) {
    var st = form && form.__leadSofort;
    if (!st) return null;
    st.done = true;
    return st.sent ? Date.now() - st.sent : null;
  }
  window.LeadSofort = { attach: attach, finish: finish, send: send, guardPhone: guardPhone, digits: digits, MIN_DIGITS: MIN_DIGITS };
})();
